import { router } from "@inertiajs/react";
import UploadDropzone from "./UploadDropzone";

interface Props {
  directUploadPath: string;
  /** Takes the signed ids once the bytes are in the bucket. */
  imagesPath: string;
  remainingBytes: number;
}

export default function ImageUploader({
  directUploadPath,
  imagesPath,
  remainingBytes,
}: Props) {
  return (
    <UploadDropzone
      directUploadPath={directUploadPath}
      accept="image/*"
      title="Drag images here"
      hint="Uploaded straight to storage — large files don't pass through the site."
      remainingBytes={remainingBytes}
      onUploaded={(uploaded) =>
        router.post(
          imagesPath,
          { signed_ids: uploaded.map((u) => u.signedId) },
          { preserveScroll: true },
        )
      }
    />
  );
}
